import { apiCouponsFetcher } from '@/api/fetcher';
import { COUPONS_URLS } from '@/constants/api';
import { operations } from '@/api/skippay/generated/couponsApi';
import { slugify } from '@/utils/string';

type CategoriesResponse =
	| operations['categoriesList']['responses']['200']['content']['application/json']
	| undefined;

export type Category = {
	id: string;
	name: string;
	slug: string;
};

export async function getCategories(): Promise<Category[]> {
	const response = await apiCouponsFetcher<Promise<CategoriesResponse>>(
		COUPONS_URLS.categoriesList,
		{
			searchParams: {
				limit: 30,
			},
		}
	);

	const categoriesList = await response.json;

	return (
		categoriesList?.data.map((category) => ({
			id: category.id,
			name: category.name,
			slug: slugify(category.name),
		})) || []
	);
}
